import React, { useContext } from 'react'
import { Box, CircularProgress, Collapse, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import { ExpandLess, ExpandMore } from '@mui/icons-material'
import sportIcon from '../../config/sportIcon'
import theme from '../../theme'
import Context from '../../Context'
import Leagues from './Leagues'

function AllSports({ sports, openSport, setOpenSport }) {
  const { setSelectedEvent, setShowSettings } = useContext(Context)

  const handleToggle = (index) => {
    setSelectedEvent(null)
    setShowSettings(false)
    setOpenSport((prevOpenItem) => (prevOpenItem === index ? null : index))
  }

  const rowsSports = sports.map((item, index) => {
    const sportName = item[0]
    const leaguesArr = item[1]

    return(
      <React.Fragment key={'sport-fragment-' + index}>
        <ListItem disablePadding>
          <ListItemButton
            onClick={() => handleToggle(sportName)}
            sx={{
              '&:hover': {
                backgroundColor: theme.palette.secondary.main,
              },
              backgroundColor: openSport === sportName ? theme.palette.secondary.main : 'inherit',
            }}
          >
            <ListItemIcon sx={{ color: 'white', minWidth: 'auto', marginRight: '10px' }}>{sportIcon(sportName)}</ListItemIcon>
            <ListItemText sx={{ color: 'white' }} primary={sportName} />
            {openSport === sportName ? <ExpandLess sx={{ color: 'white' }} /> : <ExpandMore sx={{ color: 'white' }} />}
          </ListItemButton>
        </ListItem>
        <Collapse in={openSport === sportName} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <Leagues groupName={'All Sports'} sportName={sportName} leaguesArr={leaguesArr} />
          </List>
        </Collapse>
      </React.Fragment>
    )
  })

  return(
    <>
      {
        sports.length > 0
          ? <List sx={{ backgroundColor: theme.palette.primary.main }}>
              {rowsSports}
            </List>
          : <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70px' }}>
            <CircularProgress color="secondary" />
          </Box>
      }
    </>

  )

}

export default AllSports